/* SellAbroad integration */
(function () {
  if (window.__saCoreLoaded) return;
  window.__saCoreLoaded = true;

  var MERCHANT_ID = '01KT0ZKTHBFM09YAFMD78N79RQ';
  var SA_API_KEY = '2264fb45af1419f74adb9eb7d128184454b90e9fca6e6d6b8b2d10b4667af91e';
  var GEO_ALLOWED = ['AE','AT','AU','BE','BG','BH','CA','CH','CY','CZ','DE','DK','EE','EG','ES','FI','FR','GB','GR','HR','HU','IE','IT','JP','KW','LI','LT','LU','LV','MT','MY','NL','NO','NZ','OM','PL','PT','QA','RO','SA','SE','SG','SI','SK','TH','US'];
  var COUNTRY_TO_CCY = {
    AE:'AED', AT:'EUR', AU:'AUD', BE:'EUR', BG:'BGN', BH:'BHD', CA:'CAD', CH:'CHF', CY:'EUR', CZ:'CZK', DE:'EUR', DK:'DKK', EE:'EUR', EG:'EGP', ES:'EUR', FI:'EUR', FR:'EUR', GB:'GBP', GR:'EUR', HR:'EUR', HU:'HUF', IE:'EUR', IT:'EUR', JP:'JPY', KW:'KWD', LI:'CHF', LT:'EUR', LU:'EUR', LV:'EUR', MT:'EUR', MY:'MYR', NL:'EUR', NO:'NOK', NZ:'NZD', OM:'OMR', PL:'PLN', PT:'EUR', QA:'QAR', RO:'RON', SA:'SAR', SE:'SEK', SG:'SGD', SI:'EUR', SK:'EUR', TH:'THB', US:'USD'
  };
  var CURRENCY_DECIMALS = { AED:2,SAR:2,QAR:2,EGP:2,KWD:3,OMR:3,BHD:3,USD:2,EUR:2,GBP:2,INR:2,AUD:2,CAD:2,SGD:2,BGN:2,CZK:2,DKK:2,HUF:2,PLN:2,RON:2,SEK:2,CHF:2,NOK:2,JPY:0,MYR:2,NZD:2,THB:2 };
  var CURRENCY_SYMBOL = {
    USD:'$', EUR:'€', GBP:'£', AED:'AED ', SAR:'SAR ', QAR:'QAR ', EGP:'EGP ', KWD:'KWD ', OMR:'OMR ', BHD:'BHD ', AUD:'A$ ', CAD:'CA$ ', SGD:'SGD ', BGN:'лв ', CZK:'Kč ', DKK:'kr ', HUF:'Ft ', PLN:'zł ', RON:'lei ', SEK:'SEK ', CHF:'CHF ', NOK:'NOK ', JPY:'¥', MYR:'RM ', NZD:'NZ$ ', THB:'฿'
  };
  var BNPL_ALLOWED = ['AE','SA','EG'];
  var US_PAYMENT_METHODS_ALLOWED = ['US','AU','CA','GB'];
  var PAYMENT_ICON_LIST = [
    { name:'Visa', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/visa.png' },
    { name:'Mastercard', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/mastercard.svg' },
    { name:'American Express', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/amex.svg' },
    { name:'Apple Pay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/apple-black.svg' },
    { name:'Google Pay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/google-pay.png' },
    { name:'Tabby', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/tabby.png' },
    { name:'Tamara', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/tamara.png' },
    { name:'Klarna', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/klarna.svg' },
    { name:'Affirm', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/affirm.svg' },
    { name:'Afterpay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/afterpay.svg' },
    { name:'Amazon Pay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/amazon-pay.svg' },
    { name:'Cash App', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/cashapp.svg' },
    { name:'Zip', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/zip.svg' }
  ];
  var COUNTRY_FOOTER_ICONS = {
    AE:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Tabby','Tamara'],
    SA:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Tabby','Tamara'],
    EG:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Tabby','Tamara'],
    KW:['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    OM:['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    BH:['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    QA:['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    US:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Klarna','Affirm','Afterpay','Amazon Pay','Cash App','Zip'],
    GB:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Afterpay'],
    AU:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Afterpay','Amazon Pay','Zip'],
    CA:['Visa','Mastercard','American Express','Apple Pay','Google Pay','Affirm','Afterpay','Amazon Pay']
  };
  var DEFAULT_FOOTER_ICONS = ['Visa','Mastercard','American Express','Apple Pay','Google Pay'];

  window.__SA_GEO_ALLOWED = GEO_ALLOWED;
  window.__SA_BNPL_ALLOWED = BNPL_ALLOWED;
  window.__SA_US_PAYMENT_METHODS_ALLOWED = US_PAYMENT_METHODS_ALLOWED;
  window.__saMerchantId = MERCHANT_ID;

  var cartId, mirrorPromise;
  var shopCurrency = 'INR';
  var bnplObserver = null, bnplObserverRaf = null;

  var SA_MODE_PENDING = 'pending', SA_MODE_ALLOWED = 'allowed', SA_MODE_DISALLOWED = 'disallowed';
  var shopfloLoadPromise = null;
  window.__saMode = SA_MODE_PENDING;
  window.__saGeoResolved = false;
  window.__saUseThemeDrawer = false;

  function isGeoAllowed(c) { return !!c && GEO_ALLOWED.indexOf(c) !== -1; }
  function getSaMode() { return window.__saMode || SA_MODE_PENDING; }
  function setSaMode(m) { window.__saMode = m; window.__saUseThemeDrawer = (m === SA_MODE_ALLOWED); }
  function stopEvent(e) { if (!e) return; if (e.preventDefault) e.preventDefault(); if (e.stopPropagation) e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  function preventDefaultOnly(e) { if (e && e.preventDefault) e.preventDefault(); }
  function log() { if (window.__saDebug) console.log.apply(console, ['[SA]'].concat([].slice.call(arguments))); }
  function warn() { console.warn.apply(console, ['[SA]'].concat([].slice.call(arguments))); }

  var __saGeoResolve;
  window.__saGeoReady = new Promise(function (r) { __saGeoResolve = r; });

  /* ---------------- Deferred third-party loading ---------------- */
  function getFloHandler(n) { return typeof window[n] === 'function' ? window[n] : null; }
  function hasFloHandlers() { return !!(getFloHandler('handleFloCartBtn') || getFloHandler('handleFloCheckoutBtn') || getFloHandler('handleFloBuyNowBtn')); }
  function callFloCart() { var f = getFloHandler('handleFloCartBtn'); if (!f) return false; f(); return true; }
  function callFloCheckout() { var f = getFloHandler('handleFloCheckoutBtn'); if (!f) return false; f(); return true; }
  function callFloBuyNow(e) { var f = getFloHandler('handleFloBuyNowBtn'); if (!f) return false; f(e); return true; }
  function loadFlo() {
    if (getSaMode() === SA_MODE_ALLOWED) return Promise.resolve(false);
    if (hasFloHandlers()) return Promise.resolve(true);
    if (shopfloLoadPromise) return shopfloLoadPromise;
    shopfloLoadPromise = new Promise(function (resolve) {
      var settled = false;
      function done(ok) { if (settled) return; settled = true; if (!ok) shopfloLoadPromise = null; resolve(ok); }
      function appendScript(src, cb) { var s = document.createElement('script'); s.src = src; s.async = true; s.onload = cb; s.onerror = cb; document.head.appendChild(s); }
      function finalize() { setTimeout(function () { done(hasFloHandlers()); }, 80); }
      appendScript('https://bridge.shopflo.com/js/shopflo.bundle.js', function () {
        if (hasFloHandlers()) { finalize(); return; }
        appendScript('https://d24sh1msnqkirc.cloudfront.net/shopflo.bundle.js', finalize);
      });
      setTimeout(function () { if (!settled) done(hasFloHandlers()); }, 6000);
    });
    return shopfloLoadPromise;
  }

  /* Open the native cart drawer */
  function openThemeCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d) { if (!d.hasAttribute('open')) d.setAttribute('open', ''); }
    else window.location.href = '/cart';
  }

  /* ---------------- Meta cookie helpers ---------------- */
  function getCookieSa(name) {
    try { var row = document.cookie.split('; ').find(function (r) { return r.indexOf(name + '=') === 0; }); return row ? row.split('=').slice(1).join('=') : null; }
    catch (e) { return null; }
  }
  function rebuildFbcFromFbclid() {
    var existing = getCookieSa('_fbc'); if (existing) return existing;
    var fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (!fbclid) return null;
    return 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid;
  }
  function getMetaParams() {
    var fbp = getCookieSa('_fbp'); var fbc = getCookieSa('_fbc') || rebuildFbcFromFbclid();
    var p = {}; if (fbp) p.fbp = fbp; if (fbc) p.fbc = fbc; return p;
  }

  /* ---------------- Currency conversion ---------------- */
  function formatMoneyUnits(amount, currency) {
    var rounded = Math.round(amount);
    var nf = new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    if (CURRENCY_SYMBOL[currency]) return CURRENCY_SYMBOL[currency] + nf.format(rounded);
    return nf.format(rounded) + ' ' + currency;
  }
  function getSourceCurrency() {
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (active && typeof active === 'string') return active.toUpperCase();
    return 'INR';
  }
  function queryPriceNodes(root) {
    root = root || document;
    var sel = '.money, .price-item, .totals__subtotal-value, .cart-item__price, .cart-item__total, .cart-item__old-price, .cart-item__final-price';
    var nodes = [].slice.call(root.querySelectorAll(sel));
    return nodes.filter(function (n) {
      if (!n || !n.textContent) return false;
      /* Skip third-party-managed price nodes */
      if (n.closest('.was_price, .current_price, .js-was-price, .js-current-price, .js-savings')) return false;
      if (n.tagName === 'SCRIPT' || n.tagName === 'STYLE') return false;
      /* Keep only leaf price nodes (skip wrappers that contain another price node) */
      if (n.querySelector('.money, .price-item, .sa-price-visible')) return false;
      return true;
    });
  }
  function ensureBaseAmountStamped(node) {
    if (!node || node.dataset.saBase) return;
    /* Use the stamped original amount if present */
    var bucksEl = (node.hasAttribute && node.hasAttribute('bucks-original')) ? node : (node.querySelector ? node.querySelector('[bucks-original]') : null);
    if (bucksEl) {
      var orig = bucksEl.getAttribute('bucks-original');
      if (orig) { var bm = orig.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); if (bm) { node.dataset.saBase = String(parseFloat(bm[1])); return; } }
    }
    var txt = (node.textContent || '').replace(/,/g, '').trim();
    var num = txt.match(/(\d+(?:\.\d+)?)/);
    if (num) node.dataset.saBase = String(parseFloat(num[1]));
  }
  function setVisiblePrice(el, formatted) {
    var vis = el.querySelector('.sa-price-visible');
    if (vis && vis.textContent === formatted) return; /* skip identical content */
    if (!vis) { vis = document.createElement('span'); vis.className = 'sa-price-visible'; }
    vis.textContent = formatted;
    var sr = el.querySelector('.sr-only, .visually-hidden');
    if (sr) el.replaceChildren(sr.cloneNode(true), document.createTextNode(' '), vis);
    else el.replaceChildren(vis);
    el.dataset.saPriced = '1';
  }
  function convertStamped(node, rate, targetCurrency) {
    if (!node || !node.dataset) return;
    var base = parseFloat(node.dataset.saBase);
    if (isNaN(base)) return;
    setVisiblePrice(node, formatMoneyUnits(base * rate, targetCurrency));
  }
  /* Currency conversion for inline price text */
  var SA_INLINE_PRICE_RE = /₹\s*(\d[\d,]*(?:\.\d{1,2})?)|Rs\.?\s*(\d[\d,]*(?:\.\d{1,2})?)/g;
  var SA_INLINE_PRICE_SELECTORS = '.product__price, .announcement-bar__item, .product-info__offer-list, .offer, .product-info__description, .product-info__text, .badge';
  function hasInlineSource(text) { return !!text && (text.indexOf('₹') !== -1 || text.indexOf('Rs') !== -1); }
  function convertInlinePrices(rate, targetCurrency, root) {
    if (!rate || !targetCurrency) return;
    root = root || document;
    var containers;
    try { containers = root.querySelectorAll(SA_INLINE_PRICE_SELECTORS); } catch (e) { return; }
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      if (!c || !hasInlineSource(c.textContent)) continue;
      var walker = document.createTreeWalker(c, 4 /* SHOW_TEXT */, null, false);
      var nodes = [], tn;
      while ((tn = walker.nextNode())) { if (hasInlineSource(tn.nodeValue)) nodes.push(tn); }
      for (var k = 0; k < nodes.length; k++) {
        var node = nodes[k], val = node.nodeValue;
        var out = val.replace(SA_INLINE_PRICE_RE, function (m, a1, a2) {
          var raw = (a1 != null ? a1 : a2);
          var amt = parseFloat(String(raw).replace(/,/g, ''));
          if (isNaN(amt)) return m;
          return formatMoneyUnits(amt * rate, targetCurrency);
        });
        if (out !== val) node.nodeValue = out;
      }
    }
  }
  var __saFxCache = {};
  function getRate(from, to) {
    var key = from + '->' + to;
    if (__saFxCache[key]) return Promise.resolve(__saFxCache[key]);
    return fetch('https://oms.sellabroad.io/currency/rates?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to), { method: 'GET', mode: 'cors', headers: { 'x-api-key': SA_API_KEY, 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { var rate = j && typeof j.rate === 'number' ? j.rate : null; if (rate) __saFxCache[key] = rate; return rate; })
      .catch(function (e) { warn('FX failed', e.message); return null; });
  }
  var __reconvRAF = null;
  function scheduleReconvert(rate, targetCurrency, root) {
    if (!rate || !targetCurrency) return;
    if (__reconvRAF) cancelAnimationFrame(__reconvRAF);
    __reconvRAF = requestAnimationFrame(function () {
      queryPriceNodes(root || document).forEach(function (n) { ensureBaseAmountStamped(n); convertStamped(n, rate, targetCurrency); });
      convertInlinePrices(rate, targetCurrency, root || document);
    });
  }
  function convertAllPrices(targetCurrency) {
    var sourceCurrency = getSourceCurrency();
    if (!targetCurrency || sourceCurrency === targetCurrency) return;
    /* Neutralise the built-in converter for geo-allowed visitors */
    if (window.bucksCC && typeof window.bucksCC.reConvert === 'function' && !window.bucksCC.__saNeutralised) {
      window.bucksCC.reConvert = function () {}; window.bucksCC.__saNeutralised = true;
    }
    getRate(sourceCurrency, targetCurrency).then(function (rate) {
      if (!rate) return;
      window.__saFxLastRate = rate; window.__saFxTargetCurrency = targetCurrency;
      scheduleReconvert(rate, targetCurrency, document);
      normalizeFpdBulkPrices();
      var mo = new MutationObserver(function () { scheduleReconvert(rate, targetCurrency, document); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener('variant:change', function () { setTimeout(function () { scheduleReconvert(window.__saFxLastRate, window.__saFxTargetCurrency, document); }, 60); });
      document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input[name="id"], select[name="id"]')) setTimeout(function () { scheduleReconvert(window.__saFxLastRate, window.__saFxTargetCurrency, document); }, 80); });
    });
  }

  /* ---------------- Mirror cart + checkout redirect ---------------- */
  function mirrorCart() {
    if (mirrorPromise) return mirrorPromise;
    mirrorPromise = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      return fetch('https://oms.sellabroad.io/carts/from-shopify', {
        method: 'POST', mode: 'cors',
        headers: { 'Content-Type': 'application/json', 'x-merchant-id': MERCHANT_ID, 'x-api-key': SA_API_KEY },
        body: JSON.stringify({ token: cart.token, currentCountryCode: window.__saGeoCountry })
      }).then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); }).then(function (j) {
        cartId = (j.medusa_cart && j.medusa_cart.id) ? j.medusa_cart.id : j.id; return cartId;
      });
    });
    return mirrorPromise;
  }
  function buildCheckoutUrl(id) {
    var host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.host;
    var url = 'https://' + host + '/pages/sa-chk/checkout?cartId=' + encodeURIComponent(id) + '&merchantId=' + encodeURIComponent(MERCHANT_ID) + '&intendedCurrencyCode=' + encodeURIComponent(shopCurrency) + '&shopUrl=' + encodeURIComponent(host);
    var meta = getMetaParams();
    if (meta.fbp) url += '&fbp=' + encodeURIComponent(meta.fbp);
    if (meta.fbc) url += '&fbc=' + encodeURIComponent(meta.fbc);
    return url;
  }
  function hijackRedirect(btn) {
    var label = btn && btn.querySelector ? (btn.querySelector('span') || btn) : btn;
    var origText = label ? label.textContent : '';
    if (btn) { btn.classList.add('sa-loading'); if ('disabled' in btn) btn.disabled = true; }
    function doRedirect() {
      if (!cartId) throw new Error('No cart id');
      window.location.href = buildCheckoutUrl(cartId);
    }
    mirrorCart().then(doRedirect).catch(function () {
      mirrorPromise = null;
      mirrorCart().then(doRedirect).catch(function () {
        if (btn) { btn.classList.remove('sa-loading'); if ('disabled' in btn) btn.disabled = false; if (label) label.textContent = origText; }
        var errEl = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
        if (errEl) errEl.textContent = 'Checkout could not load. Please try again.';
        else warn('checkout could not load');
      });
    });
  }

  /* ---------------- Buy Now ---------------- */
  function startBuyNow(variantId, triggerBtn) {
    if (!variantId) return Promise.reject(new Error('Missing variant id'));
    var origText = triggerBtn ? triggerBtn.textContent : '';
    if (triggerBtn) { triggerBtn.classList.add('sa-loading'); triggerBtn.disabled = true; }
    return fetch('https://oms.sellabroad.io/carts/buy-now', {
      method: 'POST', mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'x-merchant-id': MERCHANT_ID, 'x-api-key': SA_API_KEY },
      body: JSON.stringify({ data: [{ shopifyVariantId: variantId, quantity: 1 }], currentCountryCode: window.__saGeoCountry })
    }).then(function (r) { return r.json(); }).then(function (j) {
      var cid = (j.medusa_cart && j.medusa_cart.id) ? j.medusa_cart.id : j.id;
      if (!cid) throw new Error('No cart id');
      window.location.href = buildCheckoutUrl(cid);
    }).catch(function (err) {
      if (triggerBtn) { triggerBtn.classList.remove('sa-loading'); triggerBtn.disabled = false; triggerBtn.textContent = origText || 'Buy it now'; }
      throw err;
    });
  }
  function getVariantIdFromEvent(e) {
    var target = e && e.target && e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
    var form = (target && target.closest && target.closest('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]');
    var input = form ? form.querySelector('input[name="id"]:not([disabled]), select[name="id"]') : null;
    return { variantId: input ? input.value : null, triggerBtn: target };
  }

  /* ---------------- Action dispatchers ---------------- */
  window.__saCartAction = function (e) {
    var mode = getSaMode();
    if (mode === SA_MODE_ALLOWED) { stopEvent(e); openThemeCartDrawer(); return false; }
    if (mode === SA_MODE_DISALLOWED) {
      if (callFloCart()) return true;
      stopEvent(e); loadFlo().then(function (ok) { if (!(ok && callFloCart())) window.location.href = '/cart'; }); return false;
    }
    stopEvent(e);
    window.__saGeoReady.then(function () {
      if (getSaMode() === SA_MODE_ALLOWED) { openThemeCartDrawer(); return; }
      if (callFloCart()) return;
      loadFlo().then(function (ok) { if (!(ok && callFloCart())) window.location.href = '/cart'; });
    });
    return false;
  };
  window.__saCheckoutAction = function (e) {
    var btn = (e && e.target && e.target.closest) ? e.target.closest('#checkout2, [name="checkout2"], [name="checkout"], [data-sa-checkout-btn]') : null;
    var mode = getSaMode();
    if (mode === SA_MODE_ALLOWED) { stopEvent(e); hijackRedirect(btn); return false; }
    if (mode === SA_MODE_DISALLOWED) {
      if (callFloCheckout()) return true;
      stopEvent(e); loadFlo().then(function (ok) { if (!(ok && callFloCheckout())) window.location.href = '/checkout'; }); return false;
    }
    stopEvent(e);
    window.__saGeoReady.then(function () {
      if (getSaMode() === SA_MODE_ALLOWED) { hijackRedirect(btn); return; }
      if (callFloCheckout()) return;
      loadFlo().then(function (ok) { if (!(ok && callFloCheckout())) window.location.href = '/checkout'; });
    });
    return false;
  };
  window.__saBuyNowAction = function (e) {
    var info = getVariantIdFromEvent(e);
    var mode = getSaMode();
    if (mode === SA_MODE_ALLOWED) { preventDefaultOnly(e); startBuyNow(info.variantId, info.triggerBtn).catch(function () {}); return false; }
    if (mode === SA_MODE_DISALLOWED) {
      if (callFloBuyNow(e)) return true;
      preventDefaultOnly(e); loadFlo().then(function (ok) { if (!(ok && callFloBuyNow(e))) { var f = info.triggerBtn && info.triggerBtn.closest('form'); if (f) f.submit(); } }); return false;
    }
    preventDefaultOnly(e);
    window.__saGeoReady.then(function () {
      if (getSaMode() === SA_MODE_ALLOWED) { startBuyNow(info.variantId, info.triggerBtn).catch(function () {}); return; }
      if (callFloBuyNow(e)) return;
      loadFlo().then(function (ok) { if (!(ok && callFloBuyNow(e))) { var f = info.triggerBtn && info.triggerBtn.closest('form'); if (f) f.submit(); } });
    });
    return false;
  };

  /* Capture-phase click safety net for geo-allowed visitors */
  document.addEventListener('click', function (e) {
    if (getSaMode() !== SA_MODE_ALLOWED) return;
    var checkoutBtn = e.target.closest && e.target.closest('#checkout2, [name="checkout2"], [data-sa-checkout-btn]');
    if (checkoutBtn) { stopEvent(e); hijackRedirect(checkoutBtn); return; }
    var buyBtn = e.target.closest && e.target.closest('#flo-buy-now-button, .shopify-payment-button__button');
    if (buyBtn) { var info = getVariantIdFromEvent(e); preventDefaultOnly(e); e.stopPropagation(); startBuyNow(info.variantId, buyBtn).catch(function () {}); return; }
  }, true);

  /* ---------------- BNPL messages ---------------- */
  function toggleBnplMessages(country) {
    var wrappers = document.querySelectorAll('[data-bnpl-wrapper], .sa-bnpl-wrapper');
    var showBnpl = country && BNPL_ALLOWED.indexOf(country) !== -1;
    var showUs = country && US_PAYMENT_METHODS_ALLOWED.indexOf(country) !== -1;
    wrappers.forEach(function (w) {
      var bnpl = w.querySelector('[data-bnpl-offer]');
      var us = w.querySelector('[data-us-payment-offer]');
      if (bnpl) bnpl.style.display = showBnpl ? 'flex' : 'none';
      if (us) {
        us.style.display = showUs ? 'flex' : 'none';
        us.querySelectorAll('[data-sa-bnpl-countries]').forEach(function (el) {
          var list = (el.getAttribute('data-sa-bnpl-countries') || '').split(',').map(function (c) { return c.trim(); });
          el.style.display = (showUs && list.indexOf(country) !== -1) ? '' : 'none';
        });
      }
      w.style.display = ((showBnpl && bnpl) || (showUs && us)) ? 'flex' : 'none';
    });
  }
  function ensureBnplObserver() {
    if (bnplObserver) return;
    bnplObserver = new MutationObserver(function () {
      if (bnplObserverRaf) cancelAnimationFrame(bnplObserverRaf);
      bnplObserverRaf = requestAnimationFrame(function () { toggleBnplMessages(window.__saGeoCountry || ''); });
    });
    bnplObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- Footer payment icons ---------------- */
  function updateFooterPayments(country) {
    var row = document.getElementById('sa-footer-payment-row');
    var container = document.getElementById('sa-footer-payment-icons');
    if (!row || !container) return;
    if (!isGeoAllowed(country)) { row.style.display = 'none'; return; }
    var key = String(country).toUpperCase();
    var names = COUNTRY_FOOTER_ICONS[key] || DEFAULT_FOOTER_ICONS;
    var signature = names.join('|');
    row.style.display = 'flex';
    if (container.dataset.saSig === signature) return;
    container.dataset.saSig = signature;
    var map = {}; PAYMENT_ICON_LIST.forEach(function (i) { if (!map[i.name]) map[i.name] = i; });
    container.innerHTML = '';
    names.map(function (n) { return map[n]; }).filter(Boolean).forEach(function (icon) {
      var li = document.createElement('li');
      var img = document.createElement('img');
      img.src = icon.src; img.alt = icon.name; img.title = icon.name; img.loading = 'lazy';
      li.appendChild(img); container.appendChild(li);
    });
  }

  /* ---------------- Geo-conditional element toggling ---------------- */
  function toggleByGeo(country) {
    var allowed = isGeoAllowed(country);
    if (document.body) document.body.classList.toggle('sa-geo-allowed', allowed);
    /* Geo-conditional widget visibility */
    document.querySelectorAll('#whatsappbtn').forEach(function (el) { el.style.setProperty('display', allowed ? 'none' : '', 'important'); });
    /* Express checkout widget visibility */
    document.querySelectorAll('[data-sellabroad-express-checkout]').forEach(function (w) { if (!allowed) { w.classList.remove('sa-express-checkout-ready'); } });
    /* Geo-conditional third-party overlay visibility */
    if (allowed) {
      var flo = document.getElementById('flo-container'); if (flo) flo.style.setProperty('display', 'none', 'important');
    }
  }
  var __saFloHideObs = null;
  function ensureFloHideObserver() {
    if (__saFloHideObs || typeof MutationObserver === 'undefined') return;
    __saFloHideObs = new MutationObserver(function (muts) {
      if (!isGeoAllowed(window.__saGeoCountry || '')) return;
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.id === 'flo-container' || (n.querySelector && n.querySelector('#flo-container')))) {
            var flo = document.getElementById('flo-container'); if (flo) flo.style.setProperty('display', 'none', 'important');
            return;
          }
        }
      }
    });
    __saFloHideObs.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- Express checkout widget ---------------- */
  function ensureSellabroadWidgetScript(onReady) {
    function tryReady() { if (window.SellabroadExpressCheckout && typeof window.SellabroadExpressCheckout.reinitialize === 'function') { if (onReady) onReady(); return true; } return false; }
    if (document.querySelector('script[data-sellabroad-widget]')) {
      if (tryReady()) return;
      var iv = setInterval(function () { if (tryReady()) clearInterval(iv); }, 100);
      setTimeout(function () { clearInterval(iv); }, 15000);
      return;
    }
    var script = document.createElement('script');
    script.type = 'text/javascript'; script.async = true; script.setAttribute('data-sellabroad-widget', 'true');
    fetch('https://app.sellabroad.com/api/widget', { headers: { 'ngrok-skip-browser-warning': '69420' } })
      .then(function (r) { return r.text(); })
      .then(function (code) {
        script.textContent = code; document.head.appendChild(script);
        setTimeout(function () { if (tryReady()) return; var iv = setInterval(function () { if (tryReady()) clearInterval(iv); }, 100); setTimeout(function () { clearInterval(iv); }, 5000); }, 300);
      })
      .catch(function (e) { warn('express widget failed', e); });
  }
  function expressHasContent(el) { if (!el) return false; if (el.children && el.children.length) return true; try { return el.getBoundingClientRect().height > 10; } catch (e) { return false; } }
  function setupExpressReveal(w) {
    if (w.dataset.saExpressRevealBound === '1') return;
    w.dataset.saExpressRevealBound = '1';
    function markReady() {
      if (w.classList.contains('sa-express-checkout-ready')) return true;
      if (!expressHasContent(w)) return false;
      w.classList.add('sa-express-checkout-ready');
      if (w.__mo) { w.__mo.disconnect(); w.__mo = null; }
      if (w.__poll) { clearInterval(w.__poll); w.__poll = null; }
      return true;
    }
    if (markReady()) return;
    w.__mo = new MutationObserver(function () { markReady(); });
    w.__mo.observe(w, { childList: true, subtree: true });
    var ticks = 0;
    w.__poll = setInterval(function () { ticks++; if (markReady() || ticks > 70) { clearInterval(w.__poll); w.__poll = null; if (w.__mo) { w.__mo.disconnect(); w.__mo = null; } } }, 150);
  }
  function initExpressWidgets() {
    var widgets = document.querySelectorAll('[data-sellabroad-express-checkout]');
    if (!widgets.length || !isGeoAllowed(window.__saGeoCountry || '')) return;
    widgets.forEach(function (w) { w.setAttribute('data-merchant-id', MERCHANT_ID); setupExpressReveal(w); });
    if (window.SellabroadExpressCheckout && window.SellabroadExpressCheckout.reinitialize) { try { window.SellabroadExpressCheckout.reinitialize(); } catch (e) {} }
  }
  function syncExpressVariant() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])') || document.querySelector('form[action*="/cart/add"] select[name="id"]');
    var v = input && input.value; if (!v) return;
    document.querySelectorAll('[data-sellabroad-express-checkout]').forEach(function (w) { w.setAttribute('data-merchant-id', MERCHANT_ID); w.setAttribute('data-variant-id', v); setupExpressReveal(w); });
    if (window.SellabroadExpressCheckout && window.SellabroadExpressCheckout.reinitialize) { try { window.SellabroadExpressCheckout.reinitialize(); } catch (e) {} }
  }
  /* Re-initialise the widget when a section re-render replaces its container */
  var __saExpressObs = null;
  function ensureExpressObserver() {
    if (__saExpressObs || typeof MutationObserver === 'undefined') return;
    __saExpressObs = new MutationObserver(function () {
      if (!isGeoAllowed(window.__saGeoCountry || '')) return;
      if (document.querySelector('[data-sellabroad-express-checkout]:not([data-sa-express-reveal-bound])')) initExpressWidgets();
    });
    __saExpressObs.observe(document.body, { childList: true, subtree: true });
  }
  function initExpressCheckout() {
    if (!document.querySelectorAll('[data-sellabroad-express-checkout]').length) return;
    ensureSellabroadWidgetScript(function () { initExpressWidgets(); ensureExpressObserver(); });
  }
  document.addEventListener('change', function (e) {
    if (!isGeoAllowed(window.__saGeoCountry || '')) return;
    if (e.target && e.target.matches && e.target.matches('input[name="id"], select[name="id"]')) syncExpressVariant();
  });
  document.addEventListener('variant:change', function () { if (isGeoAllowed(window.__saGeoCountry || '')) setTimeout(syncExpressVariant, 60); });

  /* ---------------- Bulk-order price display ---------------- */
  /* Normalise price display in the app-rendered bulk-order form */
  function normalizeFpdBulkPrices() {
    var form = document.querySelector('.custom-fancy-bulk-order');
    if (!form) return;
    var allowed = isGeoAllowed(window.__saGeoCountry || '');
    var rate = window.__saFxLastRate, ccy = window.__saFxTargetCurrency;
    if (allowed && !(rate && ccy)) return; /* wait for FX to avoid a flash */
    form.querySelectorAll('.fpd-bo-variant-price, .fpd-bo-total-price').forEach(function (el) {
      var cur = el.textContent || '';
      if (!/<span[^>]*money[^>]*>/i.test(cur)) return; /* only act on raw, not already-rendered, output */
      var out = cur.replace(/<span[^>]*class=["']?money["']?[^>]*>([^<]*)<\/span>/gi, function (full, inner) {
        var m = inner.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
        if (!m) return full;
        var amt = parseFloat(m[1]);
        return (allowed && rate && ccy) ? formatMoneyUnits(amt * rate, ccy) : inner.trim();
      });
      if (out !== cur) el.textContent = out;
    });
  }
  function ensureFpdBulkObserver() {
    if (window.__saFpdBulkObs || typeof MutationObserver === 'undefined') return;
    var run = function () { if (window.__saFpdBulkRaf) cancelAnimationFrame(window.__saFpdBulkRaf); window.__saFpdBulkRaf = requestAnimationFrame(normalizeFpdBulkPrices); };
    window.__saFpdBulkObs = new MutationObserver(run);
    window.__saFpdBulkObs.observe(document.body, { childList: true, subtree: true });
    run();
  }

  /* ---------------- Geolocation + init ---------------- */
  setSaMode(SA_MODE_PENDING);
  function applyGeo(country) {
    country = country || '';
    window.__saGeoCountry = country;
    window.__saGeoResolved = true;
    setSaMode(isGeoAllowed(country) ? SA_MODE_ALLOWED : SA_MODE_DISALLOWED);
    if (__saGeoResolve) { __saGeoResolve(); __saGeoResolve = null; }
    shopCurrency = COUNTRY_TO_CCY[country] || shopCurrency;
    toggleByGeo(country);
    toggleBnplMessages(country);
    updateFooterPayments(country);
    ensureBnplObserver();
    ensureFpdBulkObserver();
    if (getSaMode() === SA_MODE_ALLOWED) {
      convertAllPrices(shopCurrency);
      ensureFloHideObserver();
      initExpressCheckout();
    } else {
      document.querySelectorAll('[data-sellabroad-express-checkout]').forEach(function (el) { el.style.setProperty('display', 'none', 'important'); });
      loadFlo();
    }
  }
  /* Geolocation */
  var __saForceGeo = null;
  try { __saForceGeo = new URLSearchParams(window.location.search).get('sa_force_geo'); } catch (e) {}
  if (__saForceGeo) {
    applyGeo(__saForceGeo.toUpperCase());
  } else {
    var __saGeoPromise = (window.__saGeoFetch && typeof window.__saGeoFetch.then === 'function')
      ? window.__saGeoFetch
      : fetch('https://oms.sellabroad.io/geolocation', { method: 'GET', mode: 'cors', headers: { 'x-api-key': SA_API_KEY, 'x-merchant-id': MERCHANT_ID, 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(r.status)); });
    __saGeoPromise
      .then(function (res) {
        var country = res && res.data && res.data.country_code ? String(res.data.country_code).toUpperCase() : '';
        applyGeo(country);
      })
      .catch(function () {
        var fallback = (window.Shopify && window.Shopify.country) ? String(window.Shopify.country).toUpperCase() : '';
        applyGeo(fallback);
      });
  }

  /* Re-apply geo toggles as the DOM hydrates */
  var geoMo = new MutationObserver(function () { if (window.__saGeoCountry !== undefined) toggleByGeo(window.__saGeoCountry); });
  geoMo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* SellAbroad analytics */
(function () {
  if (window.__saAnalyticsLoaded) return;
  window.__saAnalyticsLoaded = true;
  function initAnalytics() {
    var MERCHANT_ID = window.__saMerchantId;
    var ALLOWED = (window.__SA_GEO_ALLOWED && Array.isArray(window.__SA_GEO_ALLOWED)) ? window.__SA_GEO_ALLOWED : null;
    if (!MERCHANT_ID || !ALLOWED) { if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAnalytics); return; } setTimeout(initAnalytics, 500); return; }
    if (!window.__saGeoResolved) {
      if (window.__saGeoReady && window.__saGeoReady.then && !window.__saAnalyticsWaitingGeo) {
        window.__saAnalyticsWaitingGeo = true;
        window.__saGeoReady.then(function () { window.__saAnalyticsWaitingGeo = false; initAnalytics(); }).catch(function () { window.__saAnalyticsWaitingGeo = false; });
      }
      return;
    }
    var userCountry = window.__saGeoCountry || (window.Shopify && window.Shopify.country) || null;
    if (!userCountry || ALLOWED.indexOf(userCountry) === -1) return;
    var LAMBDA_URL = 'https://b2jywk2yden2oocqceroukp3zm0hokcd.lambda-url.eu-west-1.on.aws/';
    var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
    function uuid() { return Math.random().toString(36).slice(2) + Date.now(); }
    function setCookie(n, v, d) { d = d || 365; document.cookie = n + '=' + v + '; expires=' + new Date(Date.now() + d * 864e5).toUTCString() + '; path=/; SameSite=Lax'; }
    function getCookie(n) { try { var row = document.cookie.split('; ').find(function (r) { return r.indexOf(n + '=') === 0; }); return row ? row.split('=')[1] : null; } catch (e) { return null; } }
    function post(metric_type, visitor_id) { try { fetch(LAMBDA_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ merchant_id: MERCHANT_ID, metric_type: metric_type, visitor_id: visitor_id, country: userCountry }) }); } catch (e) {} }
    var visitorId = getCookie('__sa_v');
    if (!visitorId) { visitorId = uuid(); setCookie('__sa_v', visitorId); post('VISITOR', visitorId); }
    var sessionId = getCookie('__sa_s'); var lastActive = Number(getCookie('__sa_la') || 0); var now = Date.now();
    if (!sessionId || now - lastActive > SESSION_TIMEOUT_MS) { sessionId = uuid(); setCookie('__sa_s', sessionId); post('SESSION', visitorId); }
    setCookie('__sa_la', now, 1);
    var ATC_SELECTORS = "form[action*='/cart/add'] [type='submit'], button[name='add'], .add-to-cart, [id*='AddToCartButton']";
    var lastATC = 0;
    function sendATC() { var n = Date.now(); if (n - lastATC < 1000) return; lastATC = n; post('ATC', visitorId); }
    function bindATC() { document.querySelectorAll(ATC_SELECTORS).forEach(function (btn) { if (!btn.dataset.saBound) { btn.dataset.saBound = '1'; btn.addEventListener('pointerdown', sendATC, { passive: true }); } }); }
    bindATC();
    new MutationObserver(bindATC).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAnalytics); else initAnalytics();
})();
